export default __webpack_public_path__ + "static/media/example-deliverables.5b18c74d.svg";